<template>
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    :fill="clr ? clr : 'none'"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.55556 12.1831H5.33333V6.09155H3.55556V12.1831ZM7.11111 12.1831H8.88889V3.48088H7.11111V12.1831ZM10.6667 12.1831H12.4444V8.70221H10.6667V12.1831ZM1.77778 15.664C1.28889 15.664 0.87037 15.4936 0.522222 15.1527C0.174074 14.8119 0 14.4022 0 13.9235V1.74044C0 1.26182 0.174074 0.852091 0.522222 0.511255C0.87037 0.170418 1.28889 0 1.77778 0H14.2222C14.7111 0 15.1296 0.170418 15.4778 0.511255C15.8259 0.852091 16 1.26182 16 1.74044V13.9235C16 14.4022 15.8259 14.8119 15.4778 15.1527C15.1296 15.4936 14.7111 15.664 14.2222 15.664H1.77778ZM1.77778 13.9235H14.2222V1.74044H1.77778V13.9235Z"
      :fill="clr ? clr : 'none'"
    />
  </svg>
</template>

<script>
export default {
  props: ["clr"]
};
</script>

<style lang="scss" scoped></style>
